import { Box, Table, TableScrollContainer } from "@mantine/core";

/**
 * A table component for the home page.
 *
 * @param {children} - the content to be displayed inside the table
 * @returns styled table component specially for home page tables
 */

const HomePageTable = ({ children }) => {
  return (
    <Box
      style={(theme) => ({
        borderRadius: theme.radius.md,
        overflow: "hidden",
      })}
    >
      <TableScrollContainer
        maxHeight={210}
        scrollAreaProps={{
          scrollHideDelay: 600,
          offsetScrollbars: false,
        }}
      >
        <Table
          stickyHeader
          styles={(theme) => ({
            td: {
              padding: theme.spacing.xs,
              backgroundColor: theme.colors.gray[1],
            },
            tr: { border: "none" },
            th: {
              borderBottom: "2px solid ",
              borderColor: theme.colors.gray[4],
              backgroundColor: theme.colors.gray[2],
            },
          })}
        >
          {children}
        </Table>
      </TableScrollContainer>
    </Box>
  );
};

export default HomePageTable;
